exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3XO3497afLl5UpsNwhccTr{display:flex;flex-direction:row;align-items:center}._1KDSnUnMj9Q2sXgLZLy950{display:flex;flex-direction:column}._9RmWGBdEFJDILGwz1miZX{align-items:stretch}._3sgbKCmbAkDT5bYCLqr2bO{flex:1}", ""]);
// Exports
exports.locals = {
	"horizontal": "_3XO3497afLl5UpsNwhccTr",
	"vertical": "_1KDSnUnMj9Q2sXgLZLy950",
	"stretch": "_9RmWGBdEFJDILGwz1miZX",
	"blank": "_3sgbKCmbAkDT5bYCLqr2bO"
};